export const initialState={
    isLoggedIn: false,
    manualRefresh: true,
    IsAuthenticated : false,
    UserID:"",
    Questions:{},
    companyId : "",
    eligibility: localStorage.getItem("eligibility") || "",
    course_eligibility: localStorage.getItem("course_eligibility") || ""
}

export const actionTypes = {
    SET_IS_LOGGEDIN : 'SET_IS_LOGGEDIN',
    SET_MANUAL_REFRESH : 'SET_MANUAL_REFRESH',
    SET_ISAUTHENTICATED : 'SET_ISAUTHENTICATED',
    SET_UserID:'SET_UserID',
    SET_Questions:'SET_Questions',
    SET_COMPANYID : 'SET_COMPANYID',
    SET_Eligibility : 'SET_Eligibility',
    SET_Course_Eligibility: 'SET_Course_Eligibility'
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_IS_LOGGEDIN:
            {
                return{
                    ...state,
                    isLoggedIn:action.isLoggedIn
                }
            }
            case actionTypes.SET_MANUAL_REFRESH:
            {
                return{
                    ...state,
                    manualRefresh:action.manualRefresh
                }
            }
            case actionTypes.SET_ISAUTHENTICATED:
            {
                return{
                    ...state,
                    IsAuthenticated:action.IsAuthenticated
                }
            }
            case actionTypes.SET_UserID:
                {
                    return{
                        ...state,
                        UserID:action.UserID
                    }
                }
                case actionTypes.SET_Questions:
                    {
                        return{
                            ...state,
                            Questions:action.Questions
                        }
                    }
                case actionTypes.SET_COMPANYID:
                {
                    return{
                        ...state,
                        companyId:action.companyId
                    }
                }

                  case actionTypes.SET_Eligibility:
                {
                    return{
                        ...state,
                        eligibility:action.SET_Eligibility
                    }
                }
                 case actionTypes.SET_Course_Eligibility:
                {
                    return{
                        ...state,
                        course_eligibility:action.SET_Course_Eligibility
                    }
                }
                
                
            default:
                return state;
    }
}
export default reducer;